module.exports = __webpack_public_path__ + "static/media/video_uploaded_placeholder.48dc4e34.svg";